import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Heart, Mail, Github, Linkedin, TriangleAlert } from 'lucide-react';
import AnchorLink from './ui/AnchorLink';

export default function Footer() {
  
  return (
    <footer className="bg-white border-t border-slate-100 mt-auto">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/home-page" className="flex items-center gap-2 mb-4">
              <AppLogo size={32} />
              <span className="font-bold text-xl bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                Insighta AI
              </span>
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
              AI-powered tongue analysis for early diabetes risk detection. Empowering Filipinos and communities worldwide with accessible health insights.
            </p>

            {/* SOCIAL LOGO */}
            <div className="flex items-center gap-3 mt-5">

              <AnchorLink
                href="/about-page?social=linkedin#team"
                className="p-2 rounded-xl bg-slate-50 hover:bg-blue-50 transition"
              >
                <Linkedin size={16} />
              </AnchorLink>

              <AnchorLink
                href="/about-page?social=email#team"
                className="p-2 rounded-xl bg-slate-50 hover:bg-blue-50 transition"
              >
                <Mail size={16} />
              </AnchorLink>

              <AnchorLink
                href="/about-page?social=github#team"
                className="p-2 rounded-xl bg-slate-50 hover:bg-blue-50 transition"
              >
                <Github size={16} />
              </AnchorLink>

            </div>

          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-slate-800 text-sm mb-4">Navigation</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', href: '/home-page' },
                { label: 'About Us', href: '/about-page' },
                { label: 'How It Works', href: '/how-it-works' },
                { label: 'FAQ', href: '/faq' },
              ]?.map((link) => (
                <li key={link?.href}>
                  <Link href={link?.href} className="text-sm text-slate-500 hover:text-blue-600 transition-colors">
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-slate-800 text-sm mb-4">Legal</h4>
              <ul className="space-y-2.5">
                <li>
                  <AnchorLink
                    href="/about-page#ethics"
                    className="text-sm text-slate-500 hover:text-blue-600 transition-colors"
                  >
                    Ethics
                  </AnchorLink>
                </li>

                <li>
                <AnchorLink
                  href="/how-it-works#behind-insighta"
                  className="text-sm text-slate-500 hover:text-blue-600 transition-colors"
                >
                  Disclaimer
                </AnchorLink>
                </li>

                <li>
                  <Link
                    href="https://forms.gle/FMNowR1DB3jeKHzt8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-500 hover:text-blue-600 transition-colors"
                  >
                    Contact Support
                  </Link>
                </li>
              </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400">
            © 2026 Insighta AI. All rights reserved.
          </p>
          <p className="text-xs text-slate-400 flex items-center gap-1">
            Built with <Heart size={12} className="text-red-400 fill-red-400" /> for early health awareness.
          </p>
          <p className="flex items-center gap-1 text-xs bg-amber-50 text-amber-600 px-3 py-1 rounded-full border border-amber-100 whitespace-nowrap">
            <TriangleAlert size={12} className="text-amber-600" />
            Not a substitute for medical diagnosis
          </p>
        </div>
      </div>
    </footer>
  );
}